// src/components/DataTableCartas.js
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  IconFileText,
} from "@tabler/icons-react";
import PDFViewer from './PDF/PDFViewer'; // Importe o componente que acabamos de criar

const DataTable = ({ title, newButtonRoute, data, onUpdate, isAdmin, excelButtonRoute}) => {
  const zonaMapping = {
    sem_endereco: "Sem Endereço",
    oeste: "Oeste",
    leste: "Leste",
    norte: "Norte",
    sul: "Sul",
    centrosul: "Centro Sul",
    centrooeste: "Centro Oeste",
    rural: "Rural",
  };
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(8);
  const [selectedCarta, setselectedCarta] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Modal de exclusão
  const [editCarta, seteditCarta] = useState(null);
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  //Visualizador de PDF
  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState('');

  const handleSearchChange = (e) => setSearch(e.target.value);
  const handleEntriesChange = (e) => {
    setEntries(e.target.value);
    setCurrentPage(1); // Reseta para a primeira página sempre que o número de entradas mudar
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  // Filtra os dados com base na busca
  const filteredData = data.filter((item) =>
    item.solicitante.toLowerCase().includes(search.toLowerCase())
  );
  const sortedData = [...filteredData].sort((a, b) => new Date(b.data_recebimento) - new Date(a.data_recebimento));

  // Cálculos de paginação
  const numericEntries = Number(entries);
  const totalRecords = sortedData.length;
  const totalPages = Math.ceil(totalRecords / numericEntries);
  const startIndex = (currentPage - 1) * numericEntries;
  const paginatedData = sortedData.slice(startIndex, startIndex + numericEntries);

  // Função para mudar de página
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Renderiza os botões de paginação
  const renderPagination = () => {
    let pages = [];
    if (totalPages <= 7) {
      // Se o número total de páginas é pequeno, exibe todas
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Sempre exibe a primeira página
      pages.push(1);
  
      // Define o intervalo de páginas ao redor da página atual
      let start = Math.max(currentPage - 1, 2);
      let end = Math.min(currentPage + 1, totalPages - 1);
  
      // Ajusta o intervalo se a página atual estiver perto do início ou do fim
      if (currentPage <= 3) {
        start = 2;
        end = 4;
      }
      if (currentPage >= totalPages - 2) {
        start = totalPages - 3;
        end = totalPages - 1;
      }
  
      // Se houver um gap entre a primeira página e o início do intervalo, insere ellipsis
      if (start > 2) {
        pages.push("ellipsis");
      }
  
      // Adiciona as páginas do intervalo
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
  
      // Se houver um gap entre o final do intervalo e a última página, insere ellipsis
      if (end < totalPages - 1) {
        pages.push("ellipsis");
      }
  
      // Sempre exibe a última página
      pages.push(totalPages);
    }
  
    return pages.map((page, index) => {
      if (page === "ellipsis") {
        return (
          <li key={index} className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      } else {
        return (
          <li key={index} className={`page-item ${page === currentPage ? "active" : ""}`}>
            <button className="page-link" onClick={() => handlePageChange(page)}>
              {page}
            </button>
          </li>
        );
      }
    });
  };

  const handleView = (carta) => {
    setselectedCarta(carta);
    setShowViewModal(true);
  };

  const handleEdit = (carta) => {
    seteditCarta({ ...carta });
    setShowEditModal(true);
  };

  const handleDelete = (carta) => {
    setselectedCarta(carta);
    setShowDeleteModal(true);
  };

  const handleEditItemChange = (index, field, value) => {
    let itens = [];
    if (Array.isArray(editCarta.itens_atendidos)) {
      itens = [...editCarta.itens_atendidos];
    } else {
      try {
        itens = JSON.parse(editCarta.itens_atendidos);
      } catch (e) {
        itens = [];
      }
    }
    itens[index] = { ...itens[index], [field]: value };
    seteditCarta({ ...editCarta, itens_atendidos: itens });
  };
  
  const handleAddItemEdit = () => {
    let itens = [];
    if (Array.isArray(editCarta.itens_atendidos)) {
      itens = [...editCarta.itens_atendidos];
    } else {
      try {
        itens = JSON.parse(editCarta.itens_atendidos);
      } catch (e) {
        itens = [];
      }
    }
    itens.push({ quantidade: "", item: "" });
    seteditCarta({ ...editCarta, itens_atendidos: itens });
  };
  
  const handleRemoveItemEdit = (index) => {
    let itens = [];
    if (Array.isArray(editCarta.itens_atendidos)) {
      itens = [...editCarta.itens_atendidos];
    } else {
      try {
        itens = JSON.parse(editCarta.itens_atendidos);
      } catch (e) {
        itens = [];
      }
    }
    itens.splice(index, 1);
    seteditCarta({ ...editCarta, itens_atendidos: itens });
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}cartas/${selectedCarta.id}/`, {
        method: "DELETE",
      });

      if (response.ok) {
        setShowDeleteModal(false);
        if (typeof onUpdate === "function") {
          onUpdate();
        }
      } else {
        console.error("Erro ao excluir o registro.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  const handleCloseView = () => setShowViewModal(false);
  const handleCloseEdit = () => setShowEditModal(false);
  const handleCloseDelete = () => setShowDeleteModal(false);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    let updatedCarta = { ...editCarta };

    if (name === "categoria_id") {
      const selectedCategory = categories.find((cat) => String(cat.id) === value);
      updatedCarta.categoria = selectedCategory || null;
    } else if (name === "telefone") {
      updatedValue = formatTelefone(value);
      updatedCarta[name] = updatedValue;
    } else if (name === "data_recebimento") {
      updatedValue = formatData(value);
      updatedCarta[name] = updatedValue;
    } else if (name === "carta_digital") {
      const file = e.target.files && e.target.files[0];
      if (file) {
        updatedCarta[name] = file;
      }
    } else {
      updatedCarta[name] = updatedValue;
    }
    seteditCarta(updatedCarta);
  };

  const handleEditSubmit = async () => {
    const updatedData = { ...editCarta };
    updatedData.categoria_id = editCarta.categoria.id;
    updatedData.data_recebimento = formatData(editCarta.data_recebimento);
    if (updatedData.itens_atendidos) {
      updatedData.itens_atendidos = JSON.stringify(updatedData.itens_atendidos);
    }

    // Check if a new file was provided for carta_digital
    if (updatedData.carta_digital && updatedData.carta_digital instanceof File) {
      // Renomeia o arquivo antes de enviar
      const originalFile = updatedData.carta_digital;
      const extension = originalFile.name.split('.').pop();
      const currentYear = new Date().getFullYear();
      const formattedDate = updatedData.data_recebimento.replace(/\//g, "-");
      const newFileName = `${updatedData.solicitante}_${formattedDate}_${currentYear}.${extension}`;
      const renamedFile = new File([originalFile], newFileName, { type: originalFile.type });
      updatedData.carta_digital = renamedFile;

      const formData = new FormData();
      for (const key in updatedData) {
        formData.append(key, updatedData[key]);
      }
      try {
        const response = await fetch(`${API_BASE_URL}cartas/${editCarta.id}/`, {
          method: "PUT",
          body: formData,
        });
        if (response.ok) {
          setShowEditModal(false);
          if (typeof onUpdate === "function") {
            onUpdate();
          }
        } else {
          console.error("Erro ao atualizar o registro.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      }
    } else {
      // Se não houver um novo arquivo, remove o campo carta_digital para manter o já registrado
      delete updatedData.carta_digital;
      const formData = new FormData();
      for (const key in updatedData) {
        formData.append(key, updatedData[key]);
      }
      try {
        const response = await fetch(`${API_BASE_URL}cartas/${editCarta.id}/`, {
          method: "PUT",
          body: formData,
        });
        if (response.ok) {
          setShowEditModal(false);
          if (typeof onUpdate === "function") {
            onUpdate();
          }
        } else {
          console.error("Erro ao atualizar o registro.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      }
    }
  };

  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };

  const formatData = (value) => {
    if (value.includes("-")) {
      const parts = value.split("-");
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
    }
    const digits = value.replace(/\D/g, "").substring(0, 8);
    let formatted = digits;
    if (digits.length >= 3) {
      formatted = digits.substring(0, 2) + "/" + digits.substring(2, 4);
    }
    if (digits.length >= 5) {
      formatted += "/" + digits.substring(4, 8);
    }
    return formatted;
  };
  
  const formatCPF = (value) => {
    if (!value) return "";
    // Remove all non-digit characters
    value = value.replace(/\D/g, "");
    // Limit to 11 digits
    value = value.substring(0, 11);
    if (value.length > 9) {
      // Format as 999.999.999-99
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, "$1.$2.$3-$4");
    } else if (value.length > 6) {
      // Format as 999.999.999
      return value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1.$2.$3");
    } else if (value.length > 3) {
      // Format as 999.999
      return value.replace(/(\d{3})(\d{0,3})/, "$1.$2");
    }
    return value;
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}cartas/categorias/`);
        if (res.ok) {
          const data = await res.json();
          setCategories(data);
        } else {
          console.error("Erro ao buscar categorias");
        }
      } catch (error) {
        console.error("Erro na requisição de categorias:", error);
      }
    };
    fetchCategories();
  }, [API_BASE_URL]);

// Função para abrir o visualizador de PDF com correção para HTTPS e caminho
const handleOpenPdfViewer = (url) => {
  // Primeiro remove o ":8000" como você já fazia
  let formattedUrl = url.replace(":8000", "");
  
  // Converte para HTTPS se a URL for HTTP
  if (formattedUrl.startsWith('http://')) {
    formattedUrl = formattedUrl.replace('http://', 'https://');
  }
  
  // Remove qualquer barra extra no final da URL
  if (formattedUrl.endsWith('/')) {
    formattedUrl = formattedUrl.slice(0, -1);
  }
  
  console.log("URL do PDF formatada:", formattedUrl); // Para debug
  
  setCurrentPdfUrl(formattedUrl);
  setShowPdfViewer(true);
};

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title">{title}</h3>
        <div className="btn-list">
          <NavLink to={newButtonRoute} className="btn btn-primary d-flex align-items-center">
            <span className="ms-1">Novo</span>
          </NavLink>
          <div className="btn-list">
                <a
                  href={excelButtonRoute}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  className="btn btn-success d-flex align-items-center"
                >
                  <span className="ms-1">Excel</span>
                </a>
              </div>
        </div>
      </div>

      <div className="card-body border-bottom py-3">
        <div className="d-flex">
          <div className="text-secondary">
            Mostrar{" "}
            <div className="mx-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={entries}
                onChange={handleEntriesChange}
                size="3"
                aria-label="Contador de registros"
              />
            </div>
            registros
          </div>
          <div className="ms-auto text-secondary">
            Procurar:
            <div className="ms-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={search}
                onChange={handleSearchChange}
                aria-label="Procurar"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table table-vcenter text-nowrap datatable">
          <thead>
            <tr>
              <th className="w-1">
                <input
                  className="form-check-input m-0 align-middle"
                  type="checkbox"
                  aria-label="Selecionar todos os registros"
                />
              </th>
              <th className="w-1">Data do Recebimento</th>
              <th>Solicitante</th>
              <th>Solicitação</th>
              <th>Telefone</th>
              <th>Bairro</th>
              <th>Zona</th>
              <th>Status do Pedido</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item) => (
                <tr key={item.id}>
                  <td>
                    <input
                      className="form-check-input m-0 align-middle"
                      type="checkbox"
                      aria-label="Selecione o registro"
                    />
                  </td>
                  <td>
                    <span className="text-secondary">{formatDate(item.data_recebimento)}</span>
                  </td>
                  <td>{truncateText(item.solicitante, 20)}</td>
                  <td>{truncateText(item.solicitacao || "Sem assunto", 30)}</td>
                  <td>{formatTelefone(item.telefone)}</td>
                  <td>{truncateText(item.bairro, 30)}</td>
                  <td>{truncateText(zonaMapping[item.zona] || item.zona, 30)}</td>
                  <td>
                      <span className={`badge ${
                        item.status === "resolvido" ? "bg-success" :
                        item.status === "inexecutavel" ? "bg-danger" :
                        item.status === "pendente" ? "bg-warning" : "bg-secondary"
                      } me-1 text-white`}>
                        {item.status === "resolvido" ? "Resolvido" :
                        item.status === "inexecutavel" ? "Inviável" :
                        item.status === "pendente" ? "Pendente" : item.status}
                      </span>
                  </td>
                  <td className="text-end">
                    <span className="dropdown">
                      <button className="btn dropdown-toggle align-text-top" data-bs-toggle="dropdown">
                        Ações
                      </button>
                      <div className="dropdown-menu dropdown-menu-end">
                        <button className="dropdown-item" onClick={() => handleView(item)}>
                          Ver
                        </button>
                        <button className="dropdown-item" onClick={() => handleEdit(item)}>
                          Editar
                        </button>
                        {isAdmin && (
                          <button className="dropdown-item text-red" onClick={() => handleDelete(item)}>
                            Excluir
                          </button>
                        )}
                      </div>
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center text-muted">
                  Não existem cartas cadastradas
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Rodapé com paginação */}
      <div className="card-footer d-flex align-items-center justify-content-between">
        <p className="m-0 text-secondary">
          Exibindo{" "}
          <span>{(currentPage - 1) * numericEntries + 1}</span> até{" "}
          <span>{Math.min(currentPage * numericEntries, totalRecords)}</span> de{" "}
          <span>{totalRecords}</span> registros
        </p>
        <ul className="pagination m-0">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={(e) => {
                e.preventDefault();
                if (currentPage > 1) handlePageChange(currentPage - 1);
              }}
            >
              ante
            </button>
          </li>
          {renderPagination()}
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}> 
            <button
              className="page-link"
              onClick={(e) => {
                e.preventDefault();
                if (currentPage < totalPages) handlePageChange(currentPage + 1);
              }}
            >
              prox
            </button>
          </li>
        </ul>
      </div>

      {/* Modal para visualização da Carta */}
      <Modal show={showViewModal} onHide={handleCloseView}>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes da Carta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {selectedCarta ? (
              <div>
                <p>
                  <strong>Data do Recebimento:</strong> {formatDate(selectedCarta.data_recebimento)}
                </p>
                {/* Exibe o CPF logo após a data, se o status for "resolvido" */}
                {selectedCarta.status === "resolvido" && (
                  <p>
                    <strong>CPF:</strong> {formatCPF(selectedCarta.cpf)}
                  </p>
                )}
                <p>
                  <strong>Solicitante:</strong> {selectedCarta.solicitante}
                </p>
                <p>
                  <strong>Telefone:</strong> {formatTelefone(selectedCarta.telefone)}
                </p>
                <p>
                  <strong>Endereço:</strong> {selectedCarta.endereco}
                </p>
                <p>
                  <strong>Bairro:</strong> {selectedCarta.bairro}
                </p>
                <p>
                  <strong>Zona:</strong> {zonaMapping[selectedCarta.zona] || selectedCarta.zona}
                </p>
                <p>
                  <strong>Solicitação:</strong> {selectedCarta.solicitacao}
                </p>
                <p>
                  <strong>Categoria:</strong> {selectedCarta.categoria.nome}
                </p>
                <p>
                  <strong>Encaminhar:</strong> {selectedCarta.encaminhar}
                </p>
                <p>
                  <strong>Informações Adicionais:</strong> {selectedCarta.info_adicionais}
                </p>
                <p>
                  <strong>Observação:</strong> {selectedCarta.observacao}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span className={`badge ${
                    selectedCarta.status === "resolvido" ? "bg-success" :
                    selectedCarta.status === "inexecutavel" ? "bg-danger" :
                    selectedCarta.status === "pendente" ? "bg-warning" : "bg-secondary"
                  } me-1 text-white`}>
                    {selectedCarta.status === "resolvido" ? "Resolvido" :
                    selectedCarta.status === "inexecutavel" ? "Inviável" :
                    selectedCarta.status === "pendente" ? "Pendente" : selectedCarta.status}
                  </span>
                </p>
                {/* Exibe Itens Atendidos abaixo do Status se o status for "resolvido" */}
                {selectedCarta.status === "resolvido" && (
                    <div className="mt-3">
                      <p className="fw-bold">Itens Atendidos:</p>
                      {(() => {
                        let itens = [];
                        if (selectedCarta.itens_atendidos) {
                          if (Array.isArray(selectedCarta.itens_atendidos)) {
                            itens = selectedCarta.itens_atendidos;
                          } else {
                            try {
                              itens = JSON.parse(selectedCarta.itens_atendidos);
                            } catch (e) {
                              itens = [];
                            }
                          }
                        }
                        return itens.length > 0 ? (
                          <table className="table table-sm">
                            <thead>
                              <tr>
                                <th style={{ width: "30%" }}>Quantidade</th>
                                <th>Item</th>
                              </tr>
                            </thead>
                            <tbody>
                              {itens.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.quantidade}</td>
                                  <td>{item.item}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-muted">Nenhum item atendido</p>
                        );
                      })()}
                    </div>
                  )}
               {selectedCarta.carta_digital && (
                <p>
                  <strong>Carta Digitalizada:</strong>{" "}
                  <Button
                    variant="primary"
                    onClick={() => handleOpenPdfViewer(selectedCarta.carta_digital)}
                    title="Visualizar carta digitalizada"
                  >
                    <IconFileText />
                  </Button>
                </p>
              )}
              
              {/* Componente do visualizador de PDF */}
              <PDFViewer 
                pdfUrl={currentPdfUrl}
                show={showPdfViewer}
                onHide={() => setShowPdfViewer(false)}
              />
            </div>
          ) : (
            <p>Carregando...</p>
          )}
          </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseView}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de exclusão */}
      <Modal show={showDeleteModal} onHide={handleCloseDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza de que deseja excluir a carta de <strong>{selectedCarta?.solicitante}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Excluir</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para edição da Carta */}
      <Modal show={showEditModal} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Carta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editCarta ? (
            <form>
              <div className="mb-3">
                <label className="form-label">Data do Recebimento</label>
                <input
                  type="text"
                  className="form-control"
                  name="data_recebimento"
                  value={formatData(editCarta.data_recebimento)}
                  onChange={handleEditChange}
                  placeholder="DD/MM/YYYY"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Local Recebido</label>
                <input
                  type="text"
                  className="form-control"
                  name="local_recebimento"
                  value={editCarta.local_recebimento}
                  onChange={handleEditChange}
                />
              </div>
              {editCarta.status === "resolvido" && (
                  <div className="mb-3">
                    <label className="form-label">CPF</label>
                    <input
                      type="text"
                      className="form-control"
                      name="cpf"
                      value={formatCPF(editCarta.cpf)}
                      onChange={handleEditChange}
                    />
                  </div>
                )}
              <div className="mb-3">
                <label className="form-label">Solicitante</label>
                <input
                  type="text"
                  className="form-control"
                  name="solicitante"
                  value={editCarta.solicitante}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Telefone</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefone"
                  value={formatTelefone(editCarta.telefone)}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Endereço</label>
                <input
                  type="text"
                  className="form-control"
                  name="endereco"
                  value={editCarta.endereco}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Bairro</label>
                <input
                  type="text"
                  className="form-control"
                  name="bairro"
                  value={editCarta.bairro}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Zona</label>
                <select
                  className="form-select"
                  name="zona"
                  value={editCarta.zona}
                  onChange={handleEditChange}
                >
                  <option value="sem_endereco">Sem Endereço</option>
                  <option value="norte">Norte</option>
                  <option value="sul">Sul</option>
                  <option value="leste">Leste</option>
                  <option value="oeste">Oeste</option>
                  <option value="centrooeste">Centro Oeste</option>
                  <option value="centrosul">Centro Sul</option>
                  <option value="rural">Rural</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Solicitação</label>
                <input
                  type="text"
                  className="form-control"
                  name="solicitacao"
                  value={editCarta.solicitacao}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Categoria</label>
                <select
                  className="form-select"
                  name="categoria_id"
                  value={editCarta.categoria.id}
                  onChange={handleEditChange}
                >
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Encaminhar</label>
                <input
                  type="text"
                  className="form-control"
                  name="encaminhar"
                  value={editCarta.encaminhar}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Informações Adicionais</label>
                <input
                  type="text"
                  className="form-control"
                  name="info_adicionais"
                  value={editCarta.info_adicionais}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Observação</label>
                <input
                  type="text"
                  className="form-control"
                  name="observacao"
                  value={editCarta.observacao}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Status</label>
                <select
                  className="form-select"
                  name="status"
                  onChange={handleEditChange}
                  value={editCarta.status}
                >
                  <option value="inexecutavel">Inviável</option>
                  <option value="pendente">Pendente</option>
                  <option value="resolvido">Resolvido</option>
                </select>
              </div>
              {editCarta.status === "resolvido" && (
              <div className="mb-3">
                <label className="form-label">Itens Atendidos</label>
                {Array.isArray(editCarta.itens_atendidos) && editCarta.itens_atendidos.length > 0 ? (
                  <div>
                    {editCarta.itens_atendidos.map((item, index) => (
                      <div key={index} className="d-flex mb-2">
                        <input
                          type="number"
                          className="form-control me-2"
                          placeholder="Quantidade"
                          value={item.quantidade}
                          onChange={(e) => handleEditItemChange(index, "quantidade", e.target.value)}
                        />
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder="Item"
                          value={item.item}
                          onChange={(e) => handleEditItemChange(index, "item", e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => handleRemoveItemEdit(index)}
                        >
                          Remover
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">Nenhum item atendido</p>
                )}
                <button type="button" className="btn btn-secondary mt-2" onClick={handleAddItemEdit}>
                  Adicionar Item
                </button>
              </div>
            )}
              <div className="mb-3">
                <label className="form-label">Carta Digitalizada</label>
                <input
                  type="file"
                  accept="application/pdf"
                  className="form-control"
                  name="carta_digital"
                  onChange={handleEditChange}
                />
              </div>
            </form>
          ) : (
            <p>Carregando...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>Cancelar</Button>
          <Button variant="primary" onClick={handleEditSubmit}>Salvar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DataTable;